var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcrumb"},_vm._l((_vm.paths),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }